import { COMPLIANCE_STATUSES, STEP_COLOR_STATUSES } from 'constants/status.constants';
import { SmartTable } from '@certemy/ui-components';
import {
  ListResponse,
  ServiceQueryParam,
  TableFilters,
  WorkflowModuleHistory,
} from 'interfaces/testing-workflow.interface';
import { JobDetails, JobDetailsNote } from 'pages/verifier/details/job-details.interface';

export interface VerificationListResponse extends ListResponse<VerificationListRow> {}

export interface VerificationListCustomFilter {
  workflowName?: string;
  examName?: string;
  stepName?: string;
  organizationName?: string;
  phaseName?: string;
  complianceStatusIds?: COMPLIANCE_STATUSES[];
  workflowTypeId: number;
  organizationIds?: number[];
}

export interface VerificationListRow {
  selected?: boolean;
  workflowTypeId: number;
  organizationId: number;
  organizationName: string;
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  workflowName: string;
  examName: string;
  phaseName: string;
  stepName: string;
  dueDate: string;
  updatedAt?: string;
  lastModified?: string;
  stepInstanceColorId: STEP_COLOR_STATUSES;
  stepInstanceId?: number;
  typeId: number;
  stepTypeId?: number;
  assignedToProfileId: number;
  assignee?: {
    profileId: number;
    userId: number;
    firstName: string;
    lastName: string;
  };
  // todo add Candidate ID and #
}

// to/from service
export interface VerificationListQueryParam extends ServiceQueryParam<VerificationListCustomFilter> {}

// to/from table
export interface VerificationListTableFilters extends TableFilters<VerificationListCustomFilter> {}

export interface VerificationCellAction {
  cellType: SmartTable.ColumnTypeId;
  payload: { checked: boolean };
  row: VerificationListRow;
}

export interface VerificationJobDetails extends JobDetails {
  id: number;
  history: WorkflowModuleHistory[];
  notes: JobDetailsNote[];
  additionalData: any;
}

export enum VerificationActions {
  APPROVE,
  REJECT,
}
